const ja = {
  common: {
    facts: "数字で見る",
    why: "Hotel Ciutat Martorell が選ばれる理由",
    related: "こちらもおすすめ",
    quoteEyebrow: "ウェディングについてお聞かせください",
  },
  nearSeat: {
    seoTitle: "SEAT-CUPRA マルトレイ近くのホテル · 工場まで5分",
    seoDesc: "SEAT-CUPRA工場とマルトレイの工業団地まで5分の4つ星ホテル。法人料金、光ファイバーWi-Fi、駐車場、レストラン、駅まで100m。",
    eyebrow: "SEAT-CUPRA 訪問者向けホテル",
    title: ["SEAT-CUPRA マルトレイ工場から", "5分のホテル"],
    intro: "サプライヤー、エンジニア、トレーナー、プロジェクトチームの皆さまに選ばれる理由は、工場とマルトレイの工業団地が目と鼻の先にあり、バルセロナ行きの電車が100m先から出ているからです。",
    facts: [
      { k: "SEAT-CUPRA 工場", v: "車で5分" },
      { k: "Renfe・FGC 駅", v: "100m" },
      { k: "バルセロナ", v: "30分" },
      { k: "エル・プラット空港", v: "25分" },
    ],
    sections: [
      { h: "ビジネス滞在のための設計", p: "デスク、無料光ファイバーWi-Fi、空調を備えた21m²の客室。朝番に間に合うよう06:30〜10:30のビュッフェ朝食、遅い到着にも対応する24時間フロント、印刷やレポート作成に使えるBusiness Cornerをご用意しています。" },
      { h: "法人料金と一括請求", p: "工場を定期的に訪問される企業様には、交渉料金、一括請求、チーム予約の迅速な手配をご提供します。おおよその宿泊数をお知らせいただければ、ご提案をご用意いたします。" },
      { h: "工場のすぐそばで会議・研修", p: "35〜220m²の自然光が入る3つの会議室は、サプライヤー研修、キックオフ、監査に最適。プロジェクター、光ファイバー、コーヒーブレイク付き。レストランMy Barでは月〜金にビジネスランチメニューをご用意しています。" },
    ],
    why: [
      "SEAT-CUPRA工場とマルトレイの工業団地まで車で5分",
      "ホテル内の専用駐車場（有料）",
      "全客室に無料光ファイバーWi-Fiとデスク",
      "朝食は06:30から、フロントは24時間対応",
      "一括請求可能な法人料金",
    ],
    faqTitle: "SEAT-CUPRA 近くでの滞在について",
    cta: { title: "直接予約または法人料金のお問い合わせ", text: "公式サイトでの予約は最低価格保証。チーム向けの法人料金もご相談ください。", secondary: "法人料金", secondaryTo: "corporate" },
    related: [
      { to: "corporate", label: "ビジネスホテル" },
      { to: "meetingRooms", label: "会議室" },
      { to: "blogPost", params: { slug: "donde-alojarse-si-visitas-martorell-por-trabajo" }, label: "マルトレイ出張時の宿泊先" },
    ],
  },
  nearMontserrat: {
    seoTitle: "モンセラット近くのホテル · 修道院まで20分",
    seoDesc: "マルトレイの4つ星ホテル。モンセラットまで車で20分、登山鉄道へ向かうFGCの駅は100m先。修道院とバルセロナ観光に便利な拠点です。",
    eyebrow: "モンセラット観光の拠点ホテル",
    title: ["モンセラットまで20分、", "バルセロナまで30分"],
    intro: "マルトレイは理想的な中間地点です。午前はモンセラットの修道院と山々、午後はバルセロナへ。夜はレストランと駐車場を備えた静かな客室でおくつろぎください。",
    facts: [
      { k: "モンセラット修道院", v: "車で20分" },
      { k: "登山鉄道へのFGC電車", v: "ホテルから100m" },
      { k: "バルセロナ", v: "30分" },
      { k: "エル・プラット空港", v: "25分" },
    ],
    sections: [
      { h: "ホテルからモンセラットへの行き方", p: "車なら修道院またはモニストロルの登山鉄道駐車場まで20分。公共交通なら、FGCの駅はホテルから100m。R5線でMonistrol de Montserratまで行き登山鉄道で登るか、Montserrat-Aeriまで行きロープウェイで登ります。" },
      { h: "山で一日、ホテルで安らぎの一夜", p: "大聖堂、エスコラニア少年合唱団、サン・ジェロニへのハイキングの後は、空調、シャワー付きバスルーム、光ファイバーWi-Fiを備えた21m²の客室へ。夕食はレストランMy Barで地中海の市場料理とペネデスのワインを。" },
      { h: "モンセラットとバルセロナを組み合わせて", p: "RenfeとFGCの駅からバルセロナまで約30分。ホテルを変えることなく、また中心部の駐車場に悩まされることなく、一日をモンセラットに、もう一日を街に充てられます。" },
    ],
    why: [
      "モンセラット修道院まで車で20分",
      "100m先のFGC駅から登山鉄道・ロープウェイに接続",
      "専用駐車場に車を置いて電車で移動",
      "地中海料理とペネデスワインのレストランMy Bar",
      "山へ早出できる06:30〜10:30のビュッフェ朝食",
    ],
    faqTitle: "ホテルからのモンセラット観光について",
    cta: { title: "モンセラット観光の拠点を予約", text: "公式サイトでの直接予約は最低価格保証。グループでのご旅行はご提案をお問い合わせください。", secondary: "ホテルへのアクセス", secondaryTo: "location" },
    related: [
      { to: "blogPost", params: { slug: "como-llegar-a-montserrat-desde-martorell" }, label: "マルトレイからモンセラットへの行き方" },
      { to: "location", label: "所在地とアクセス" },
      { to: "blogPost", params: { slug: "que-visitar-cerca-de-martorell" }, label: "マルトレイ近郊の見どころ" },
    ],
  },
  parkingBarcelona: {
    seoTitle: "バルセロナ近くの駐車場付きホテル · 電車で30分",
    seoDesc: "マルトレイの専用駐車場付き4つ星ホテル。バルセロナまで30分。車を置いて、100m先の駅からRenfeまたはFGCで市内へ。公式サイトで直接予約。",
    eyebrow: "駐車場付きホテル",
    title: ["車を停めて、", "バルセロナまで30分"],
    intro: "車でバルセロナへお越しなら、中心部の外に泊まるほうが静かで簡単です。ホテルの専用駐車場に停め、玄関から100mの駅から市内へ直通の電車に乗れます。",
    facts: [
      { k: "専用駐車場", v: "ホテル内" },
      { k: "Renfe・FGC 駅", v: "100m" },
      { k: "バルセロナ中心部", v: "30分" },
      { k: "エル・プラット空港", v: "25分" },
    ],
    sections: [
      { h: "ホテル内の専用駐車場", p: "ご宿泊のお客様向けの専用駐車スペース（有料）。駐車場探しも、バルセロナ中心部の高い駐車料金も不要です。出入りは自由、お車は客室からすぐの場所に。" },
      { h: "渋滞なしで電車でバルセロナへ", p: "Renfe（Rodalies近郊線）とFGCの駅は100m先。約30分で中心部に到着し、帰りにはお車が待っています。県内を巡るなら、A-2とAP-7高速道路がすぐ隣です。" },
      { h: "小旅行に最適な充実のホテル", p: "光ファイバーWi-Fi付き21m²の客室92室、レストランMy Bar、ジム、06:30〜10:30のビュッフェ朝食。車でバルセロナやモンセラットを訪れるご家族やカップルに最適です。" },
    ],
    why: [
      "ホテル内にご宿泊者用の専用駐車場",
      "バルセロナ行きの電車まで100m：RenfeとFGC",
      "バルセロナまで30分、空港まで25分",
      "光ファイバーWi-Fi付き21m²のダブル＆ツインルーム",
      "レストラン、ジム、24時間フロント",
    ],
    faqTitle: "駐車場とバルセロナへのアクセスについて",
    cta: { title: "駐車場付きで予約して車の心配を忘れる", text: "公式サイトでの直接予約は最低価格保証。お車でお越しの際はお知らせください。", secondary: "ホテルのサービス", secondaryTo: "services" },
    related: [
      { to: "blogPost", params: { slug: "como-ir-de-martorell-a-barcelona" }, label: "マルトレイからバルセロナへの行き方" },
      { to: "services", label: "ホテルのサービス" },
      { to: "blogPost", params: { slug: "transportes-entre-martorell-y-barcelona" }, label: "マルトレイとバルセロナ間の交通" },
    ],
  },
  weddingsBaix: {
    seoTitle: "バッシュ・リュブラガットのウェディングホテル · マルトレイ",
    seoDesc: "マルトレイでの結婚式：最大150名の宴会場、テラスでの最大200名のカクテル、試食メニュー、ブライダルルーム、ゲスト向け特別料金。",
    eyebrow: "バッシュ・リュブラガットでのウェディング",
    title: ["バッシュ・リュブラガットでの結婚式を、", "すべてひとつ屋根の下で"],
    intro: "テラスでのカクテル、自然光あふれる220m²のホールでの披露宴、ホテル自慢の地中海料理、そして誰も運転して帰る必要のない92室の客室。バルセロナから30分、地域全体へのアクセスも良好です。",
    facts: [
      { k: "披露宴", v: "最大150名" },
      { k: "カクテル", v: "最大200名" },
      { k: "宴会場", v: "自然光の入る220m²" },
      { k: "客室", v: "ゲスト用に92室" },
    ],
    sections: [
      { h: "会場：テラス、ホール、客室", p: "テラスでのウェルカムカクテル、可動間仕切り付き220m²の宴会場での披露宴。宴の後は新郎新婦に無料のブライダルルームを、ご宿泊のゲストには特別料金をご用意します。" },
      { h: "自家製料理と試食メニュー", p: "当ホテルのキッチンチームが、旬の地中海食材とペネデスのワインでオーダーメイドのウェディングメニューを作ります。当日前には試食会を行い、おふたりと一品一品を決めていきます。" },
      { h: "最初のコーヒーから寄り添うコーディネーター", p: "48時間以内に確定見積もりをお届けし、追加費用の心配はありません。専任コーディネーターが進行、業者、DJ、オプションのフリードリンクを手配し、おふたりは当日を楽しむだけです。" },
    ],
    why: [
      "バルセロナや地域全体からのゲストに便利：車で30分、駅まで100m",
      "自然光の入る220m²のホールとカクテル用テラス",
      "無料ブライダルルームとゲスト向け特別料金",
      "事前の試食メニューと自家製地中海料理",
      "専任コーディネーターと48時間以内の確定見積もり",
    ],
    faqTitle: "ホテルでの結婚式について",
    cta: { title: "思い描くウェディングをお聞かせください", text: "おおよその日程、ゲストの人数、ご希望をお知らせください。48時間以内にご提案をお送りします。" },
    related: [
      { to: "weddings", label: "ホテルでのウェディング" },
      { to: "events", label: "イベント＆セレブレーション" },
      { to: "meetingRoomDetail", params: { slug: "salon-montserrat" }, label: "宴会場" },
    ],
  },
};

export default ja;
